// CREATE GLOBAL OBJECT (Google Maps, YouTube Player)
window.HERSHEYPA =  {};
window.alertFix = alertFix;
window.VertScroll = VertScroll;
window.EverScroll = EverScroll;
window.NavisIntegration = NavisIntegration;
window.EventList = EventList;
window.SignalUp = SignalUp;
window.newBGVideo = newBGVideo;
window.sanitizeId = sanitizeId;
window.menuTabs = menuTabs;
window.clickTabs = clickTabs;
window.get_tab_query = get_tab_query;
window.activateTab = activateTab;

var $maps = null;
var gMapsKey = 'AIzaSyDjVdh_7K-YSlbPwrTgXFHAptDEZPifTzA';
var maps = [];
var alertShim = null;

$(function(){
    get_tab_query();
    clickTabs();
    menuTabs();

    // Scroll to #buyatab-tabs on page load if it exists
    var tabSection = document.getElementById('buyatab-tabs');
    if (tabSection) {
        setTimeout(function() {
            tabSection.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }, 300);
    }
	$('.fp-datepicker').not('.fp-datepicker-ccf').fluffypicker({
		format: 'MM/DD/YYYY',
		minDateTime: function(){
			return moment( ).subtract( "days", 1 ); // Starting today
		},
		calendar: { saveOnDateSelect: true },
		showTime: false
	});

	$("#mbl-menu").click(function(e){
		e.preventDefault();
		$("#menubar,#mbl-menu-icon,#close-icon").toggle();
		$(".subnav,.subsubnav").hide();
	});
	$(".touch #menubar>li>a").click(function(e){
		if( $(this).next(".subnav").length>0 && !$(this).next(".subnav").is(":visible") ){
			e.preventDefault();
			$(".subnav,.subsubnav").hide();
			$(this).next(".subnav").toggle();
		}
	});
	$(".touch .subnav>ul>li>a").click(function(e){
		if( $(this).next(".subsubnav").length>0 && !$(this).next(".subsubnav").is(":visible") ){
			e.preventDefault();
			$(".subsubnav").hide();
			$(this).next(".subsubnav").toggle();
		}
	});

	var inout = '100%';
	$("#watch-video").click(function(e) {
		if(!$("html").hasClass("touch")){
			e.preventDefault();
			inout = (inout=='0'?'100%':'0');
			//$("#video-wrapper iframe").attr('src', ($("#watch-video").attr("href").replace('watch?v=','embed/')) );
			$("#yt-iframe").animate({'left': inout },750);
			$("span",this).text((inout=='0'?"Close Video":"Watch Video"));
			if(inout!='0'){     
                if(typeof ytplayer !== 'undefined' && ytplayer && typeof ytplayer.stopVideo === 'function') {
                    stopVideo(); 
                }
                senttoclosevideobtn=false; 
            }
			$(this).toggleClass("active");
			if(inout=='0'){ $("#yt-iframe").focus(); }
		}
	});

	var senttoclosevideobtn = false;
	$("#hero-txt-block a").on('focusin', function(event) {
		if( !senttoclosevideobtn && $("#watch-video").hasClass("active") ){
			senttoclosevideobtn = true;
			$("#watch-video").focus();
		}
	});

	if( $("#watch-video").length>0 && !$("html").hasClass("touch") ){
		var script = document.createElement('script');
		script.src = '//www.youtube.com/iframe_api';
		document.body.appendChild(script);

		$("#hero").prepend('<div id="video-wrapper"><div id="yt-iframe" /></div>');
		$("#watch-video").attr('title','open and play the video');
		window.videoID = $("#watch-video").attr("href").match(/(?:youtube\.com\/(?:[^\/]+\/.+\/|(?:v|e(?:mbed)?)\/|.*[?&]v=)|youtu\.be\/)([^"&?\/ ]{11})/i)[1];
	}


    if($('#upcoming-events ul#events li').length) {
        
        VertScroll.Init({
            container: $('#upcoming-events'),
            elements: $('#upcoming-events ul li')
        });
    }

    $("#map-click-image").on('click', MapClick.Click);
	/*
	 * *************************
	 * MODULE - GOOGLE MAPS
	 * *************************
	*/

    $maps = $('.gmap');
    //console.log($('form#tp-set-dates-form').length);

	if (($maps.length || $('form#tp-set-dates-form').length) && gMapsKey) {
        // LOAD GOOGLE MAPS API
        $(window).on('load', function () {
            var script = document.createElement('script');
                script.src = '//maps.googleapis.com/maps/api/js?key=' + gMapsKey + '&v=3.exp&callback=HERSHEYPA.GMAPS.init';
            document.body.appendChild(script);
        });
	}

    NavisIntegration.Init();
    
    // Skip link checker
    if($('body').hasClass('stage')) {
        if(!$('#main-content').length) {
            $('#hpa-logo').css('border', '2px solid red');
        }
    }
    
    // Initialize hover and focus events to bubble to a parent for styling
    $('#stories .white-card').each(function(i, wc) {
        if($(this).length) {
            SignalUp.Init($(wc), $(wc).find('a'));
        }
    });
    
    // This is a fix for skip links being attached to h1s within a overflow:hidden scrolling container
    $('a[href="#main-content"]').on('click', function(){
        setTimeout(function(){
            $('section#hero').scrollTop(0);
        },100);
    });

    // Create tabindex on all skip link target
    $('.skip-link').on('click', function () {
        var targetID = $(this).attr('href');
        $(targetID).attr('tabindex', 0);
    });
    
    /*
     * Scroll through and fix links in area we cannot control the DOM
     */
    $('#wff-list p a').each(function(i,a){
        var href = $(a).prop('href');
        if(href.indexOf('hersheypa') >= 0) {
            return true;
        }
        $(a).attr('target', '_blank').attr('title', 'Opens site in a new tab');
    });
    
    if($('section#alert-wrapper').length) {
        alertFix();
        
        $(window).on('resize', function(){
           alertFix(); 
        });
    }

    
	var bgVideoElement = $('#bg-video');
	if (bgVideoElement.length) {
		newBGVideo.Init(bgVideoElement);
	}
});


function alertFix() {
    var ww = $(window).width();
    
    if(alertShim === null || (alertShim === 'mobile' && ww >= 768) || (alertShim === 'desktop' && ww < 768)) {
        if(ww < 768) {
            alertShim = 'mobile';
            if(!$('section#hero #alert-wrapper').length) {
                var second = $('section#alert-wrapper').clone(true, true);
                second.addClass('skip-scan');
                $('section#hero').prepend(second);
            }
        }
        else {
            alertShim = 'desktop';
            if($('section#hero #alert-wrapper').length) {
                $('section#hero #alert-wrapper').remove();
            }
        }
    }
}

// MapClick for google maps
var MapClick = {
    loaded: false,
    segment: null,
    map: null,
    mapStyles:[{
        "elementType":"geometry",
        "stylers": [{
            "color":"#ebece7"
        }]
    },
    {
        "elementType":"labels.text.fill",
        "stylers": [{
            "color":"#3f000b"
        }]
    },
    {
        "elementType":"labels.text.stroke",
        "stylers": [{
            "color":"#ffffff"
        }]
    },
    {
        "featureType":"poi",
        "elementType":"geometry",
        "stylers": [{
            "color":"#e2dfd8"
        }]
    },
    {
        "featureType":"poi",
        "elementType":"labels.text.fill",
        "stylers": [{
            "color":"#3f000b"
        }]
    },
    {
        "featureType":"road",
        "elementType":"geometry",
        "stylers": [{
            "color":"#e2dfd8"
        }]
    },
    {
        "featureType":"road",
        "elementType":"labels.text.fill",
        "stylers": [{
            "color":"#3f000b"
        }]
    },
    {
        "featureType":"water",
        "elementType":"geometry",
        "stylers": [{
            "color":"#e2dfd8"
        },{
            "saturation":-10
        },{
            "lightness":20
        }]
    },
    {
        "featureType":"water",
        "elementType":"labels",
        "stylers": [{
            "visibility":"off"
        }]
    }],

    ApiLoaded: function(){
        var Settings = this.Settings();
        MapClick.map = new google.maps.Map(document.getElementById("map-canvas"), Settings);

        // google.maps.event.addListenerOnce(MapClick.map, 'tilesloaded', () => {
        //     console.log(document.getElementsByTagName('iframe'));
        //     document.getElementsByTagName('iframe')[0].title = mapname;
        // });
        
        // google.maps.event.addListenerOnce(MapClick.map, 'idle', function(){
        //     // Perform ADA fixes to the map
        //     $('#'+id+' img').each(function(i, img){
        //         if(typeof($(img).attr('alt')) === 'undefined') {
        //             $(img).attr('alt', 'Google Maps image');
        //         }
        //     });
            
        //     $('#'+id+' a[target=_blank]').each(function(i, atb){
        //         var title = $(atb).attr('title');
        //         if(typeof(title) === 'undefined' || title == '') {
        //             $(atb).attr('title', 'Google Maps external link');
        //         }
        //     });
        // });

        $("#map-click-image").fadeOut(250, MapClick.LoadMarker);
    },

    Click: function () {
        if (MapClick.loaded) {
            return;
        }
        MapClick.loaded = true;
        MapClick.segment = $(this).data('segment');
        jQuery.ajax({
            url: 'https://maps.googleapis.com/maps/api/js?key=' + gMapsKey + '&libraries=marker&callback=MapClick.ApiLoaded&loading=async',
            dataType: 'script',
            success: function(){
                // google.maps.event.addListenerOnce(map, 'idle', function(){
                //     // do something only the first time the map is loaded
                //     console.log(1)
                // });
            },
            async: true
        });
        if(typeof(dataLayer) !== 'undefined') {
            dataLayer.push({
                'event': 'Map Click Load',
                'map_click_status':'click'
            });
        }
    }, 
    

    LoadMarker: function(){
        var position = null;
        var icon = null;
        var mapname = null;
         
        switch(MapClick.segment){
            case 'hersheypark':
                position=new google.maps.LatLng(40.2887809,-76.6547469);
                icon='/assets/images/pin-orange.png';
                mapname= "Hersheypark Map"
            break;
                case 'hersheypark-stadium':
                position=new google.maps.LatLng(40.2899809,-76.6588469);
                icon='/assets/images/pin-orange.png';
                mapname= "Hersheypark Stadium Map"
            break;
                case 'chocolateworld':
                position=new google.maps.LatLng(40.28816,-76.6608457);
                icon='/assets/images/pin-orange.png';
                mapname= "Chocolate World Map"
            break;
                case 'hersheysocial':
                position=new google.maps.LatLng(40.285775,-76.6538399);
                icon='/assets/images/pin-orange.png';
                mapname= "Hershey Social Map"
            break;
            case 'the-hotel-hershey':
                position=new google.maps.LatLng(40.2998,-76.6597);
                icon='/assets/images/pin-orange.png';
                mapname= "The Hotel Hershey Map"
            break;
            case 'hershey-story':
                position=new google.maps.LatLng(40.2852506,-76.6521083);
                icon='/assets/images/pin-orange.png';
                mapname= "Hershey Story Map"
            break;
            case 'hershey-gardens':
                position=new google.maps.LatLng(40.2983609,-76.6562461);
                icon='/assets/images/pin-orange.png';
                mapname= "Hershey Gardens Map"
            break;
            case 'zooamerica':
                position=new google.maps.LatLng(40.2879639,-76.6515061);
                icon='/assets/images/pin-orange.png';
                mapname= "ZooAmerica Map"
            break;
            case 'cocoa-beanery':
                position=new google.maps.LatLng(40.262712,-76.686994);
                icon='/assets/images/pin-orange.png';
                mapname= "Cocoa Beanery Map"
            break;
            case 'meltspa':
                position=new google.maps.LatLng(40.286095,-76.649879);
                icon='/assets/images/pin-orange.png';
                mapname= "Meltspa Map"
            break;
            case 'giant-center':
                position=new google.maps.LatLng(40.2863875,-76.6691114);
                icon='/assets/images/pin-orange.png';
                mapname= "Giant Center Map"
            break;
            case 'aaca':
                position=new google.maps.LatLng(40.298142,-76.690149);
                icon='/assets/images/pin-orange.png';
                mapname= "aaca Map"
            break;
            case 'hershey-theatre':
                position=new google.maps.LatLng(40.285369,-76.6486197);
                icon='/assets/images/pin-orange.png';
                mapname= "Hershey Theatre Map"
            break;
        }

        var marker = new google.maps.marker.AdvancedMarkerElement({
            map: MapClick.map,
            position: position,
            content: icon ? (() => {
                const img = document.createElement('img');
                img.src = icon;
				img.className = 'marker-drop';
                return img;
            })() : undefined
        });

        switch(MapClick.segment){
            case 'hersheypark':
                marker.addListener(marker, 'click', function() {
                    window.open( 'https://www.google.com/maps?saddr=Current+Location&daddr=Hersheypark,100+West+Hersheypark+Drive,Hershey,PA' , '_blank');
                });
            break;
                case 'hersheypark-stadium':
                marker.addListener(marker, 'click', function() {
                window.open( 'https://www.google.com/maps?saddr=Current+Location&daddr=Hersheypark+Stadium,100+West+Hersheypark+Drive,Hershey,PA' , '_blank');
                });
            break;
                case 'chocolateworld':
                marker.addListener(marker, 'click', function() {
                window.open( 'https://www.google.com/maps?saddr=Current+Location&daddr=Hershey%27s+Chocolate+World,101+West+Chocolate+World+Way,Hershey,PA');
                });
            break;
            case 'the-hotel-hershey':
                marker.addListener(marker, 'click', function() {
                window.open( 'https://www.google.com/maps?saddr=Current+Location&daddr=100+Hotel+Road,Hershey,PA');
                });
            break;
            case 'hershey-story':
                marker.addListener(marker, 'click', function() {
                window.open( 'https://www.google.com/maps?saddr=Current+Location&daddr=The+Hershey+Story+Museum,63+West+Chocolate+Avenue,Hershey,PA');
                });
            break;
            case 'hershey-gardens':
                marker.addListener(marker, 'click', function() {
                window.open( 'https://www.google.com/maps?saddr=Current+Location&daddr=Hershey+Gardens,170+Hotel+Road,Hershey,PA');
                });
            break;
            case 'zooamerica':
                marker.addListener(marker, 'click', function() {
                window.open( 'https://www.google.com/maps?saddr=Current+Location&daddr=ZooAmerica+North+American+Wildlife+Park,201+Park+Avenue,Hershey,PA');
                });
            break;
            case 'cocoa-beanery':
                marker.addListener(marker, 'click', function() {
                window.open( 'https://www.google.com/maps?saddr=Current+Location&daddr=Cocoa+Beanery,1215+Research+Boulevard,Hummelstown,PA');
                });
            break;
            case 'meltspa':
                marker.addListener(marker, 'click', function() {
                window.open( 'https://www.google.com/maps?saddr=Current+Location&daddr=MeltSpa+by+Hershey,11+East+Chocolate+Avenue,Hershey,PA');
                });
            break;
            case 'giant-center':
                marker.addListener(marker, 'click', function() {
                window.open( 'https://www.google.com/maps?saddr=Current+Location&daddr=Giant+Center,550+Hersheypark+Drive,Hershey,PA');
                });
            break;
            case 'aaca':
                marker.addListener(marker, 'click', function() {
                window.open( 'https://www.google.com/maps?saddr=Current+Location&daddr=AACA+Museum,161+Museum+Drive,Hershey,PA');
                });
            break;
            case 'hershey-theatre':
                marker.addListener(marker, 'click', function() {
                window.open( 'https://www.google.com/maps?saddr=Current+Location&daddr=Hershey+Theatre,15+E.+Caracas+Avenue,Hershey,PA');
                });
            break;
            
        }
    },

    Settings: function(){
        var center= null;
        var zoom= null;
        switch(MapClick.segment){
            case 'hersheypark': 
                center=new google.maps.LatLng(40.2887809,-76.6547469);
                zoom=15;
            break;
            case 'hersheypark-stadium': 
                center=new google.maps.LatLng(40.2899809,-76.6588469);
                zoom=15;
            break;
            case 'chocolateworld': 
                center=new google.maps.LatLng(40.28816,-76.6608457);
                zoom=15;
            break;
            case 'the-hotel-hershey': 
                center=new google.maps.LatLng(40.2998,-76.6597);
                zoom=15;
            break;
            case 'hershey-story': 
                center=new google.maps.LatLng(40.2852506,-76.6521083);
                zoom=15;
            break;
            case 'hershey-gardens': 
                center=new google.maps.LatLng(40.2983609,-76.6562461);
                zoom=15;
            break;
            case 'zooamerica': 
                center=new google.maps.LatLng(40.2879639,-76.6515061);
                zoom=15;
            break;
            case 'cocoa-beanery': 
                center=new google.maps.LatLng(40.262712,-76.686994);
                zoom=15;
            break;
            case 'meltspa': 
                center=new google.maps.LatLng(40.286095,-76.649879);
                zoom=15;
            break;
            case 'giant-center': 
                center=new google.maps.LatLng(40.2863875,-76.6691114);
                zoom=15;
            break;
            case 'aaca': 
                center=new google.maps.LatLng(40.298142,-76.690149);
                zoom=15;
            break;
            case 'hershey-theatre': 
                center=new google.maps.LatLng(40.285369,-76.6486197);
                zoom=15;
            break;
        }
        var styles= {
                center: center,
                zoom: zoom,
                scrollwheel: false,
                mapTypeId: google.maps.MapTypeId.ROADMAP,
                streetViewControl: false,
                zoomControlOptions: { position: google.maps.ControlPosition.LEFT_CENTER },
                panControlOptions: { position: google.maps.ControlPosition.LEFT_CENTER },
                // styles: MapClick.mapStyles,
                mapId: gMapsKey
        };
        return styles;
    }
}

window.MapClick = MapClick;

var VertScroll = {
    // Defaults
    settings: {
        container: null,    // required
        elements: null,     // required
        speed: 6000,
        animateSpeed: 600
    },
    animate: false,
    scroll: null,
    current: null,
    eq: 0,
    goState: true,
    focus: false,
    queue: 0,
    
    Init: function(settings) {
        $.extend(VertScroll.settings, settings);

        VertScroll.current = VertScroll.settings.elements.first().show();
        VertScroll.BindKeys();
         
        VertScroll.Set();
         
        VertScroll.settings.container.hover(function(){
            VertScroll.Clear();
        }, function(){
            VertScroll.Set();
        });
        
        VertScroll.settings.elements.on('focusin', function(){
            VertScroll.focus = true;
            VertScroll.Clear();
        }).on('focusout', function(){
            VertScroll.focus = false;
            VertScroll.Set();
        });
        
        $('.events-view-switch').on('click', function(){
            VertScroll.Switch(this);
        });
    },
    
    Clear: function() {
        if(VertScroll.goState == 'stop') {
            return;
        }
        VertScroll.goState = false;
        
        clearTimeout(VertScroll.scroll);
    },
    
    Set: function() {
        if(VertScroll.goState == 'stop') {
            return;
        }
        VertScroll.goState = true;
        VertScroll.queue = 1;

        VertScroll.scroll = setTimeout(function(){
            VertScroll.Scroll();
        }, VertScroll.settings.speed);
    },
    
    BindKeys: function() {
        VertScroll.settings.elements.on('keydown', function(e){
            var absorbKey = false;
            
            switch(e.keyCode) {
                case 40: // down
                    absorbKey = true;
                    VertScroll.Scroll();
                    break;
            }
            
            if(absorbKey) {
                return false;
            }
            
            return true;
        });
    },
    
    Scroll: function() {
        if(VertScroll.animate || VertScroll.goState == 'stop') {
            return;
        }
        VertScroll.animate = true;
        var $els = VertScroll.settings.elements;

        VertScroll.current.animate({
            opacity: 0,
            marginTop: '-10px'
        },{
            duration: VertScroll.settings.animateSpeed,
            complete: function() {
                $(this).hide();
                var nextEq = VertScroll.eq + 1;
                if(nextEq >= $els.length) {
                    nextEq = 0;
                }
                var $next = $els.eq(nextEq);
                
                //console.log('EQ: ' +VertScroll.eq);
                //console.log('Next EQ: ' +nextEq);
                $next.css({
                    marginTop: '10px',
                    opacity: '0'
                }).show();
                
                $next.animate({
                    opacity: '1',
                    marginTop: '0'
                },{
                    duration: VertScroll.settings.animateSpeed,
                    complete: function() {
                        VertScroll.queue = VertScroll.queue - 1;
                        if(!VertScroll.goState) {
                            VertScroll.queue = 0;
                        }
                        else if(VertScroll.queue > 0) {
                            VertScroll.Scroll();
                        }
                        else {
                            VertScroll.scroll = setTimeout(function(){
                                if(VertScroll.goState) {
                                    VertScroll.Scroll();
                                }
                            }, VertScroll.settings.speed);
                        }
                        
                        VertScroll.animate = false;
                        if(VertScroll.focus) {
                            $next.find('a').focus();
                        }
                    }
                });
                VertScroll.current = $next;
                VertScroll.eq = nextEq;
            }
        });
    },
    
    Switch: function() {
        VertScroll.Clear();
        VertScroll.goState = 'stop';
        
        $('#events > li').css({
            'display': 'block',
            'opacity': 1,
            'marginTop': '0px'
        });
        
        $('#events > li a').attr('tabindex', 0);
        
        $('#upcoming-events').animate({
            height: $('#upcoming-events').get(0).scrollHeight
        }, 1000, function(){
            $(this).height('auto');
        }).addClass('list-view');
        
        $('#events > li a').first().focus();
        
        // Hide the button
        $('.events-view-switch').hide();
    }
    
};


var EverScroll = {
    // Defaults
    settings: {
        container: null,    // required
        elements: null,     // required
        speed: 6000,
        animateSpeed: 600
    },
    animate: null,
    current: null,
    eq: 0,
    animating: false,
    
    Init: function(settings) {
        $.extend(EverScroll.settings, settings);

        EverScroll.current = EverScroll.settings.elements.first().show();
         
        EverScroll.Set();
         
        EverScroll.settings.container.hover(function(){
            EverScroll.Clear();
        }, function(){
            EverScroll.Set();
        });
        
        EverScroll.settings.elements.on('focusin', function(){
            EverScroll.Clear();
            EverScroll.BindKeys();
            
            $(this).find('a').attr('title', 'Use down arrow to scroll');
        }).on('focusout', function(){
            if(EverScroll.animate === null) {
                EverScroll.Set();
            }

//            setTimeout(function() {
//                if(!$(':focus').parents('#events li a').length) {
//                    EverScroll.UnbindKeys();
//                    $(this).find('a').attr('title', '');
//                }
//            },1000);
            
        });
    },
    
    Clear: function() {
        EverScroll.animating = false;
        if(EverScroll.settings.container.find('.velocity-animating').length) {
            EverScroll.settings.container.find('.velocity-animating').velocity('stop').css({
                'marginTop': 0,
                'opacity': 1
            });
        }
        
        if(EverScroll.animate) {
            clearInterval(EverScroll.animate);
            EverScroll.animate = null;
        }
    },
    
    BindKeys: function() {
        EverScroll.settings.elements.on('keydown', function(e){
            var absorbKey = false;
            
            switch(e.keyCode) {
                case 40: // down
                    absorbKey = true;
                    EverScroll.Scroll(true);
                    break;
            }
            
            if(absorbKey) {
                return false;
            }
            
            return true;
        });
    },
    
    UnbindKeys: function() {
        EverScroll.settings.elements.off('keydown');
    },
    
    Set: function() {
        if(EverScroll.animate !== null) {
            return;
        }

        EverScroll.Clear();
        EverScroll.animate = setInterval(function(){
             EverScroll.Scroll();
        }, EverScroll.settings.speed);
    },
    
    Scroll: function(setFocus) {
        if(EverScroll.animating) {
            console.log('Scroll cancelled because animating still active');
            EverScroll.Clear();
            EverScroll.Set();
            return false;
        }
        if(EverScroll.settings.container.find('.velocity-animating').length) {
            console.log('Scroll called but animation still acting');
            EverScroll.Clear();
            EverScroll.Set();
            return false;
        }
        EverScroll.animating = true;
        
        if(typeof(setFocus) === 'undefined') {
            setFocus = false;
        }
        var $els = EverScroll.settings.elements;

        EverScroll.current.velocity({
            opacity: 0,
            marginTop: '-10px'
        },{
            duration: EverScroll.settings.animateSpeed,
            complete: function() {
                $(this).hide();
                var nextEq = EverScroll.eq + 1;
                if(nextEq >= $els.length) {
                    nextEq = 0;
                }
                var $next = $els.eq(nextEq);
                
                //console.log('EQ: ' +EverScroll.eq);
                //console.log('Next EQ: ' +nextEq);
                $next.css({
                    marginTop: '10px',
                    opacity: '0'
                }).show();
                $next.velocity({
                    opacity: '1',
                    marginTop: '0'
                },{
                    duration: EverScroll.settings.animateSpeed,
                    complete: function() {
                        EverScroll.animating = false;
                    }
                });
                if(setFocus) {
                    $next.find('a').focus();
                }
                EverScroll.current = $next;
                EverScroll.eq = nextEq;
            }
        });
    }
};


//ADD GMAPS STUFF TO HERSHEYPA OBJECT
window.HERSHEYPA.GMAPS = {
    maps: [],
    init: function () {
        // DEFINE MAP STYLES
        var styles = MapClick.mapStyles;

        // LOOP THROUGH ALL GOOGLE MAP STATIC IMAGES, REPLACE WITH INTERACTIVE MAP
        $maps.each(function (i) {
            var $map = $(this);
            var id ='gmaps-' + i;
            var gmap;
            var glatlng;

            // REPLACE STATIC IMAGE WITH INTERACTIVE MAP
            $map.parent().html('<div id="' + id + '" style="height:100%;"></div>');

            // CREATE INTERACTIVE MAP
            glatlng = new google.maps.LatLng(Number($map.attr('data-lat')), Number($map.attr('data-lng')));

            gmap = new google.maps.Map(document.getElementById(id), {
				mapTypeControl:false,
				streetViewControl:false,
                zoom: Number($map.attr('data-zoom')),
                center: glatlng,
                mapTypeId: google.maps.MapTypeId.ROADMAP,
                styles: styles
            });
            
            /*
             * do something only the first time the map is loaded
             * - ADA shims for gmaps for AMP
             */ 
            google.maps.event.addListenerOnce(gmap, 'idle', function(){
                // Perform ADA fixes to the map
                $('#'+id+' img').each(function(i, img){
                    if(typeof($(img).attr('alt')) === 'undefined') {
                        $(img).attr('alt', 'Google Maps image');
                    }
                });

                $('#' + id + ' iframe').prop('title', 'Google Map');
                
                $('#'+id+' a[target=_blank]').each(function(i, atb){
                    var title = $(atb).attr('title');
                    if(typeof(title) === 'undefined' || title == '') {
                        $(atb).attr('title', 'Google Maps external link');
                    }
                });
            });

            // ADD MAP TO OBJECT MAPS ARRAY
            if($(this).hasClass('trip-map')) {
                window.HERSHEYPA.GMAPS.tripMap = gmap;
            }
			else if($(this).hasClass('laundrymap')){
                var glatlng2 = new google.maps.LatLng(Number($map.attr('data-lat2')), Number($map.attr('data-lng2')));
                gmarker = new google.maps.marker.AdvancedMarkerElement({
                    map: gmap,
                    position: glatlng,
                    content: (() => {
                        const img = document.createElement('img');
                        img.src = '/assets/images/pin-orange.png';
                        img.className = 'marker-drop';
                        img.alt = $map.attr('data-title') || 'Map Pin';
                        return img;
                    })()
                });
                gmarker2 = new google.maps.marker.AdvancedMarkerElement({
                    map: gmap,
                    position: glatlng2,
                    content: (() => {
                        const img = document.createElement('img');
                        img.src = '/assets/images/pin-green.png';
                        img.className = 'marker-drop';
                        img.alt = $map.attr('data-title2') || 'Map Pin';
                        return img;
                    })()
                });
				
				var cLat = ( Number($map.attr('data-lat'))- ((Number($map.attr('data-lat')) - Number($map.attr('data-lat2'))) /2) +.0015 );
				var cLng = ( Number($map.attr('data-lng'))- ((Number($map.attr('data-lng')) - Number($map.attr('data-lng2'))) /2) );
				var clatlng = new google.maps.LatLng(cLat,cLng);

                window.HERSHEYPA.GMAPS.maps.push(gmap);
                gmap.setCenter(clatlng);
			}
            else {
                gmarker = new google.maps.Marker({
                    position: glatlng,
                    animation: google.maps.Animation.DROP,
                    map: gmap,
                    icon: '/assets/images/pin-orange.png',
                    title: $map.attr('data-title')
                });
                
                window.HERSHEYPA.GMAPS.maps.push(gmap);
            }
        });
        setInitialMapPins();
    }
};


var NavisIntegration = {
    // VERY IMPORTANT, make sure the property specific value is set here
    propertyValue: '8443301811',
    
    Init: function() {
        // Check for Navis function to make sure the script is installed
        if(typeof(AppendNavisKeywordToLink) === 'function') {
            setTimeout(function(){
                NavisIntegration.SetATags();
                NavisIntegration.SetForms();
            },1500);
        }
        else {
            console.log('Navis Integration called but either the navis.js file is not installed or there is an error.');
        }
    },
    
    SetATags: function() {
        $("a[href^='https://reservations.hersheypa.com/']").each(function(i,a){
            // Get/check the id
            var aID = $(a).prop('id');
            if(aID == '') {
                // No ID on the a tag
                var randomNum = Math.round( Math.random( ) * 100000 );
                aID = 'booking-link-'+randomNum;
                $(a).attr('id', aID);
            }
            AppendNavisKeywordToLink(aID);
        });
    },
    
    SetForms: function() {
        $("form[action^='https://misc.hersheypa.com/assets/hrs/redir/']").each(function(i,form){
            // Does the hidden NCK field exist?
            var NCK = $(form).find('input[name=NCK]');
            if(!NCK.length) {
                // Doesn't exist, insert it
                NCK = $('<input type="hidden" name="NCK" />');
                $(form).prepend(NCK);
            }
            
            // Get/set the input ID
            var ID = NCK.attr('id');
            if(typeof(ID) === 'undefined') {
                var randomNum = Math.round( Math.random( ) * 100000 );
                ID = 'nck-link-'+randomNum;
                NCK.attr('id', ID);
            }
            
            // Verify the value
            var value = NCK.val();
            if(typeof(value) === 'undefined' || value != NavisIntegration.propertyValue) {
                NCK.val(NavisIntegration.propertyValue);
            }
            NavisSetHiddenKeywordFieldD(ID, NavisIntegration.propertyValue);
        });
    }
};


/*
 * A list for upcoming events that defaults to a scrolling marquee on desktop
 * but can also serve as a list for mobile and accessibility.
 */
var EventList = {
    mode: null,
    view: 'scroll',
    scroll: null,
    delay: 6000,
  
    Init: function(){
        if($(window).width() > 1024) {
            this.mode = 'desktop';
            // Start scrolling
            EventList.Scroll.Start();
            
            $( "#events" ).hover(
                function() {
                    EventList.Scroll.Stop();
                },
                function() {
                    EventList.Scroll.Start();
                }
            );
        }
        else {
            this.mode = 'mobile';
        }
        
        $('.events-view-switch').on('click', function(){
            EventList.Switch(this);
        });
    },
    
    Switch: function(a) {
        if(EventList.mode == 'mobile') {
            return;
        }
        
        var view = $(a).data('view');
        
        if(view == 'marquee') {
            // Switch to list
            EventList.SwitchToList();
        }
    },
    
    SwitchToList: function() {
        EventList.view = 'list';
        EventList.Scroll.Stop();
        
        $('#events > li').css({
            'display': 'block',
            'opacity': 1,
            'marginTop': '0px'
        });
        
        $('#events > li a').attr('tabindex', 0);
        
        $('#upcoming_events > div').animate({
            height: $('#upcoming_events > div').get(0).scrollHeight
        }, 1000, function(){
            $(this).height('auto');
        });
        
        $('#events > li a').first().focus();
        
        // Hide the button
        $('.events-view-switch').hide();
    },
    
    Scroll: {
        
        Start: function() {
            if(EventList.view != 'scroll') {
                return;
            }
            
            EventList.scroll = setInterval( function(){ 
                EventList.Scroll.Loop(); 
            }, 
            EventList.delay );
        },
        
        Stop: function() {
            if(EventList.scroll) {
                EventList.scroll = clearInterval(EventList.scroll);
            }
        },

        Loop: function() {
            var $current = $('#events > li.active');
            if(!$current.length) {
                $current = $('#events > li').first();
                $current.show();
            }
            $current.css({'display':'list-item'});
            var $next;
            
            $current.animate({ 'opacity':'0' , 'marginTop':'-10px' }, 450, function() {
                $current.css({'display':'none'});
                $next = $(this).next('li').length ? $(this).next('li') : $(this).parent().children().first();
                $next.show();
                $next.css({'margin-top':'10px'});
                $next.animate({ 'opacity':'0'}, 0);
                $next.animate({ 'opacity':'1' , 'marginTop':'0' }, 800, "easeOutQuad");
                $next.addClass('active');
                $current.removeClass('active');
            });
        }
    }
};


function truncString(str, max, add){
   add = add || '...';
   return (typeof str === 'string' && str.length > max ? str.substring(0,max)+add : str);
};

String.prototype.truncString = function(max, add){
   add = add || '...';
   return (this.length > max ? this.substring(0,max)+add : this);
};


window.ytplayer = null;
window.onYouTubeIframeAPIReady = function() {
    window.ytplayer = new YT.Player('yt-iframe', {
        videoId: window.videoID,
        playerVars: { 'showinfo': 0, 'rel': 0, 'enablejsapi': 1 }
    });
};

window.stopVideo = function() {
    if (window.ytplayer && typeof window.ytplayer.stopVideo === 'function') {
        window.ytplayer.stopVideo();
    }
};

var SignalUp = {
  
    Init: function($wrapper, $el) {
        $el.hover(function(){
            $wrapper.addClass('hover');
        }, function(){
            $wrapper.removeClass('hover');
        });
        
        $wrapper.on('focusin', function() {
            $wrapper.addClass('focus');
        });
        $wrapper.on('focusout', function() {
            $wrapper.removeClass('focus');
        });
    }
};

function sanitizeId(str) {
    return str
        .toLowerCase()
        .replace(/[^a-z0-9]+/g, '-')
        .replace(/^-+|-+$/g, '');
}

function menuTabs() {
      // Activate tab from ?menu=... in address bar
    const params = new URLSearchParams(window.location.search);
    const menuParam = params.get('menu');
    if (menuParam) {
        const tabId = sanitizeId(menuParam);
        // Activate tab button
        document.querySelectorAll('.tab').forEach(t => {
            t.classList.toggle('active', sanitizeId(t.getAttribute('data-tab')) === tabId);
        });
        // Activate tab content
        document.querySelectorAll('.tab-content').forEach(c => {
            c.classList.toggle('active', c.id === tabId);
        });
        // Set dropdown if present
        const tabDropdown = document.querySelector('.tab-dropdown');
        if (tabDropdown) tabDropdown.value = tabId;
    }

    if (document.querySelectorAll('.tab').length) {
        const tabs = document.querySelectorAll('.tab');
        tabs.forEach((tab, idx) => {
            tab.addEventListener('click', function() {
                document.querySelectorAll('.tab').forEach(t => t.classList.remove('active'));
                document.querySelectorAll('.tab-content').forEach(c => c.classList.remove('active'));
                this.classList.add('active');
                const tabId = sanitizeId(this.getAttribute('data-tab'));
                document.getElementById(tabId).classList.add('active');
                // Update address bar with tab id, but exclude first tab (idx 0)
                if (idx !== 0) {
                    history.replaceState(null, '', `?menu=${tabId}`);
                } else {
                    history.replaceState(null, '', window.location.pathname);
                }
                // Set dropdown if present
                const tabDropdown = document.querySelector('.tab-dropdown');
                if (tabDropdown) tabDropdown.value = tabId;
            });
        });
    }
    // Only run if .tab-dropdown exists
    var tabDropdown = document.querySelector('.tab-dropdown');
    if (tabDropdown) {
        tabDropdown.addEventListener('change', function() {
            const tabId = sanitizeId(this.value);
            document.querySelectorAll('.tab-content').forEach(c => c.classList.remove('active'));
            document.getElementById(tabId).classList.add('active');
            // Set tab button if present
            document.querySelectorAll('.tab').forEach((t, idx) => {
                t.classList.toggle('active', sanitizeId(t.getAttribute('data-tab')) === tabId);
                // Update address bar with tab id, but exclude first tab (idx 0)
                if (sanitizeId(t.getAttribute('data-tab')) === tabId) {
                    if (idx !== 0) {
                        history.replaceState(null, '', `?menu=${tabId}`);
                    } else {
                        history.replaceState(null, '', window.location.pathname);
                    }
                }
            });
        });
    }
}

//Activate tab on click
function clickTabs() {
    let tabs = $('#buyatab-tabs'), btn = document.querySelectorAll('#buyatab-tabs .tabs__btn'), frame = $('.frames');
    if(tabs.length) {
        for (let i = 0; i < btn.length; i++) {
            btn[i].onclick = function() {
                activateTab(this, i);  
            } 
        }
    }
}

//activate tab on query string
function get_tab_query() {
    const params = new Proxy(new URLSearchParams(window.location.search), {
        get: (searchParams, prop) => searchParams.get(prop),
      });
    let active_tab = params.type, btn = document.querySelectorAll('#buyatab-tabs .tabs__btn'); // physical
    for (let i = 0; i < btn.length; i++) {
        let id = btn[i].id;

        if(id == active_tab) {
            activateTab(btn[i], i);
        }
    }
}


function activateTab(active_btn, i) {
    let btn = document.querySelectorAll('#buyatab-tabs .tabs__btn'), data_id = active_btn.dataset.id, iFrameID = document.getElementById('buyatab-frame');
    
    var c = 0;
    while (c < btn.length) {
    btn[c++].className = 'tabs__btn';
    }
    btn[i].className = 'tabs__btn active';

    if(iFrameID) {
        iFrameID.setAttribute("src", `https://www.buyatab.com/gcp/?id=${data_id}#customize`);
    }   
}



var newBGVideo = {
	el: null,
	spotlightr: null,
	spotlightId: null,

	Init: function ($el) {
		this.el = $el;

		if(typeof($el.data('spotlightr')) != 'undefined' && $el.data('spotlightr') != null) {

			spotlightId = $el.data('spotlightr');
			var mobileSize = $el.data('mobile');
			if (typeof mobileSize === 'undefined') {
				mobileSize = 768;
			} 
			if($(window).width()<=mobileSize){
				spotlightId = $el.data('spotlightr-mobile') ? $el.data('spotlightr-mobile') : $el.data('spotlightr');
			}
			var tag = document.createElement("script");
			tag.src = "https://videos.cdn.spotlightr.com/assets/spotlightr.js";
			document.getElementsByTagName("head")[0].appendChild(tag);

			$el.append(`<iframe allow="autoplay" class="video-player-container spotlightr" data-playerid="${spotlightId}" allowtransparency="true" aria-label="Watch video detailing about this page" name="videoPlayer" allowfullscreen="false" src="https://videos.cdn.spotlightr.com/watch/${spotlightId}?muted=0&autoplay=1&loop=1&controls=0" watch-type="" frameborder="0" scrolling="no"> </iframe>`);
		
		} 
		$("#pause-btn").on("click", function(e) {
			e.preventDefault();
			if($(this).hasClass("paused")){
				newBGVideo.Play();
			}
			else if($(this).hasClass("playing")){
				newBGVideo.Pause();
			}
		});

		let cc_btn = $("#cc-btn");
		if(cc_btn.length) {
			let btn_controls = $("#bg-video").find(".controls"),
				hero_img = $(".hero-img"), captioned = 'captioned',
				hero_text = $("#hero .hero-txt.move"), hero_txt_margin = hero_text.css('margin-top');
			if(btn_controls.length) {
				var controlspos = btn_controls.css('bottom');
			}
			
			$("#cc-btn").on("click", function(e) {
				e.preventDefault();
				if($(this).hasClass(captioned)){
					spotlightrAPI(spotlightId, 'captions', false);
					$(this).removeClass(captioned);
					
					if(hero_img.length) {
						hero_img.addClass(captioned);
					}
				}
				else{
					spotlightrAPI(spotlightId, 'captions', true);
					$(this).addClass(captioned);
					if(hero_img.length) {
						hero_img.removeClass(captioned);
					}
				}

			});
		}
        $("#mute-btn").on("click", function(e) {
            e.preventDefault();
            if($(this).hasClass("muted")){
				spotlightrAPI(spotlightId, 'volume', [1]);
                $(this).removeClass("muted");
            }
            else{
				spotlightrAPI(spotlightId, 'volume', [0]);
                $(this).addClass("muted");
            }
        });
		$(document).on('keydown', function(e){
			if(e.keyCode == 32 || e.which == 32) {
                var target = e.target;
                if(target.isContentEditable || $(target).is('input, textarea, select')) {
                    return;
                }
				$("#pause-btn").trigger('click');
                e.preventDefault();
			}
		});
	},

	Play: function () {
		$("#pause-btn").addClass('playing').removeClass('paused');
		$("#pause-btn").html($("#pause-btn").html().replace('Play', 'Pause'));
		spotlightrAPI(spotlightId, 'play');
	},

	Pause: function () {
		$("#pause-btn").addClass('paused').removeClass('playing');
		$("#pause-btn").html($("#pause-btn").html().replace('Pause', 'Play'));
		spotlightrAPI(spotlightId, 'pause');
	}
};
